import { motion } from "framer-motion";
import { PROCESS } from "@/lib/constants";
import { SectionHeader } from "@/components/Services";

export const Process = () => {
  return (
    <section id="process" data-testid="process-section" className="py-24 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader eyebrow="Our Process" title="A 5-step growth engine — proven, transparent, personal." desc="From the first consultation to scaling successful campaigns — here is exactly how we work with you." center />

        <div className="relative max-w-3xl mx-auto">
          <div className="absolute left-6 sm:left-1/2 top-2 bottom-2 w-px bg-gradient-to-b from-transparent via-[#D4AF37]/50 to-transparent" />
          <div className="flex flex-col gap-10">
            {PROCESS.map((p, i) => {
              const left = i % 2 === 0;
              return (
                <motion.div
                  key={p.step}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.55, delay: i * 0.08 }}
                  data-testid={`process-step-${i}`}
                  className={`relative pl-16 sm:pl-0 sm:grid sm:grid-cols-2 sm:gap-10 sm:items-center`}
                >
                  <div className={`absolute left-0 sm:left-1/2 -translate-x-1/2 sm:-translate-x-1/2 top-3 w-12 h-12 rounded-full grid place-items-center bg-[#050B14] border border-[#D4AF37]/50 shadow-[0_0_30px_rgba(212,175,55,0.2)] z-10`}>
                    <span className="text-[#D4AF37] font-bold text-sm">{p.step}</span>
                  </div>
                  <div className={`${left ? "sm:text-right sm:pr-16" : "sm:col-start-2 sm:pl-16"}`}>
                    <div className="text-white font-semibold text-xl tracking-tight">{p.title}</div>
                    <div className="text-white/60 text-sm mt-2 leading-relaxed">{p.desc}</div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
